import { Route, Switch } from 'react-router-dom';
import { NUVEM_PAGO_COMMONS_ROUTES } from './nuvemPagoCommonsRoutes';
import { BlockedAlertPage } from './pages/BlockedAlertPage';

export function NuvemPagoCommons() {
  return (
    <Switch>
      <Route path={NUVEM_PAGO_COMMONS_ROUTES.blockedAlert}>
        <BlockedAlertPage />
      </Route>
    </Switch>
  );
}

export * from './nuvemPagoCommonsRoutes';
export default NuvemPagoCommons;
